export default {
  isEmptyState: state => !(!!state.user || !!state.name),
  haveCompany: state => !!state.companyId && state.companyId !== 0,
};
